module.exports = __webpack_public_path__ + "static/email-template-account-activation-32314cdde41778b90042c21bf474f98f.png";